module.exports = {
          srcSet: __webpack_public_path__ + "images/1996-553bb1b89ff9096a8bfc142d44b43f79-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1996-2a78c795aa7bc508082a64bdebed1401-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1996-553bb1b89ff9096a8bfc142d44b43f79-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1996-2a78c795aa7bc508082a64bdebed1401-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1996-553bb1b89ff9096a8bfc142d44b43f79-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1996-553bb1b89ff9096a8bfc142d44b43f79-320.jpg"},
          
          width: 320,
          height: 251
        }